var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 18.3V21H9v-2.7zm-2.168-8.745-2.774-2.81L18.782 5l2.774 2.809zM12.774 16.7H10V13.89l6.169-6.245 2.774 2.809zM12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4M5 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
})));
export { SvgEditItem as ReactComponent };
export default __webpack_public_path__ + "static/media/editItem.3cef138c.svg";